"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapSessionResponse = exports.SnapSessionRequest = exports.SnapAccessTokensResponse = exports.SnapAccessTokensRequest = exports.SnapAccessTokenRequest = exports.SnapAccessTokenPrefetchHint = exports.SnapAccessToken = exports.SnapSessionResponse_Status = exports.SnapAccessTokensResponse_Status = exports.SnapTokenScope = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** For details about each scope, refer to https://github.sc-corp.net/Snapchat/sc-auth-service/blob/master/core-services/common/src/main/java/com/snapchat/auth/token/SnapScope.java */
var SnapTokenScope;
(function (SnapTokenScope) {
    /** UNKNOWN - Not known scope */
    SnapTokenScope[SnapTokenScope["UNKNOWN"] = 0] = "UNKNOWN";
    /** BLIZZARD - "https://auth.snapchat.com/snap_token/api/blizzard" */
    SnapTokenScope[SnapTokenScope["BLIZZARD"] = 1] = "BLIZZARD";
    /** LOCATION_SPRINKLER - "https://auth.snapchat.com/snap_token/api/location-sprinkler" */
    SnapTokenScope[SnapTokenScope["LOCATION_SPRINKLER"] = 2] = "LOCATION_SPRINKLER";
    /** STORIES_MIXER - "https://auth.snapchat.com/snap_token/api/stories-mixer" */
    SnapTokenScope[SnapTokenScope["STORIES_MIXER"] = 3] = "STORIES_MIXER";
    /** GTQ_UNLOCKABLES - "https://auth.snapchat.com/snap_token/api/gtq-unlockables" */
    SnapTokenScope[SnapTokenScope["GTQ_UNLOCKABLES"] = 4] = "GTQ_UNLOCKABLES";
    /** BUSINESS_ACCOUNTS - "https://auth.snapchat.com/snap_token/api/business-accounts" */
    SnapTokenScope[SnapTokenScope["BUSINESS_ACCOUNTS"] = 5] = "BUSINESS_ACCOUNTS";
    /** SERIALIZED_SHOWS - "https://auth.snapchat.com/snap_token/api/serialized-shows" */
    SnapTokenScope[SnapTokenScope["SERIALIZED_SHOWS"] = 6] = "SERIALIZED_SHOWS";
    /** MAP_GAMES - "https://auth.snapchat.com/snap_token/api/map-games" */
    SnapTokenScope[SnapTokenScope["MAP_GAMES"] = 7] = "MAP_GAMES";
    /** PUPPY - "https://auth.snapchat.com/snap_token/api/puppy-cms" */
    SnapTokenScope[SnapTokenScope["PUPPY"] = 8] = "PUPPY";
    /** API_GATEWAY - "https://auth.snapchat.com/snap_token/api/api-gateway" */
    SnapTokenScope[SnapTokenScope["API_GATEWAY"] = 9] = "API_GATEWAY";
    /** SNAP_KIT - "https://auth.snapchat.com/snap_token/api/snap-connect-snap-kit" */
    SnapTokenScope[SnapTokenScope["SNAP_KIT"] = 10] = "SNAP_KIT";
    /** LOGIN_KIT - "https://auth.snapchat.com/snap_token/api/snap-connect-login-kit" */
    SnapTokenScope[SnapTokenScope["LOGIN_KIT"] = 11] = "LOGIN_KIT";
    /** EAGLE - "https://auth.snapchat.com/snap_token/api/eagle" */
    SnapTokenScope[SnapTokenScope["EAGLE"] = 12] = "EAGLE";
    /** EXPLORE - "https://auth.snapchat.com/snap_token/api/map-explore" */
    SnapTokenScope[SnapTokenScope["EXPLORE"] = 13] = "EXPLORE";
    /** IRIS - "https://auth.snapchat.com/snap_token/api/iris" */
    SnapTokenScope[SnapTokenScope["IRIS"] = 14] = "IRIS";
    /** MULTI_SCOPE - "https://auth.snapchat.com/snap_token/api/multi-scope" */
    SnapTokenScope[SnapTokenScope["MULTI_SCOPE"] = 15] = "MULTI_SCOPE";
    /** IN_APP_APPEAL - "https://auth.snapchat.com/snap_token/api/in-app-appeal" */
    SnapTokenScope[SnapTokenScope["IN_APP_APPEAL"] = 16] = "IN_APP_APPEAL";
    SnapTokenScope[SnapTokenScope["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SnapTokenScope = exports.SnapTokenScope || (exports.SnapTokenScope = {}));
var SnapAccessTokensResponse_Status;
(function (SnapAccessTokensResponse_Status) {
    SnapAccessTokensResponse_Status[SnapAccessTokensResponse_Status["STATUS_UNKNOWN"] = 0] = "STATUS_UNKNOWN";
    SnapAccessTokensResponse_Status[SnapAccessTokensResponse_Status["STATUS_SUCCESS"] = 1] = "STATUS_SUCCESS";
    SnapAccessTokensResponse_Status[SnapAccessTokensResponse_Status["STATUS_DECODING_ERROR"] = 2] = "STATUS_DECODING_ERROR";
    SnapAccessTokensResponse_Status[SnapAccessTokensResponse_Status["STATUS_CLIENT_ID_MISMATCH"] = 3] = "STATUS_CLIENT_ID_MISMATCH";
    SnapAccessTokensResponse_Status[SnapAccessTokensResponse_Status["STATUS_NO_REFRESH_TOKEN"] = 4] = "STATUS_NO_REFRESH_TOKEN";
    SnapAccessTokensResponse_Status[SnapAccessTokensResponse_Status["STATUS_UNAUTHORIZED_SCOPE"] = 5] = "STATUS_UNAUTHORIZED_SCOPE";
    SnapAccessTokensResponse_Status[SnapAccessTokensResponse_Status["STATUS_SERVER_ERROR"] = 6] = "STATUS_SERVER_ERROR";
    SnapAccessTokensResponse_Status[SnapAccessTokensResponse_Status["STATUS_GENERIC_ERROR"] = 7] = "STATUS_GENERIC_ERROR";
    SnapAccessTokensResponse_Status[SnapAccessTokensResponse_Status["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SnapAccessTokensResponse_Status = exports.SnapAccessTokensResponse_Status || (exports.SnapAccessTokensResponse_Status = {}));
var SnapSessionResponse_Status;
(function (SnapSessionResponse_Status) {
    SnapSessionResponse_Status[SnapSessionResponse_Status["STATUS_UNKNOWN"] = 0] = "STATUS_UNKNOWN";
    SnapSessionResponse_Status[SnapSessionResponse_Status["STATUS_SUCCESS"] = 1] = "STATUS_SUCCESS";
    SnapSessionResponse_Status[SnapSessionResponse_Status["STATUS_SERVER_ERROR"] = 2] = "STATUS_SERVER_ERROR";
    SnapSessionResponse_Status[SnapSessionResponse_Status["STATUS_GENERIC_ERROR"] = 3] = "STATUS_GENERIC_ERROR";
    SnapSessionResponse_Status[SnapSessionResponse_Status["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SnapSessionResponse_Status = exports.SnapSessionResponse_Status || (exports.SnapSessionResponse_Status = {}));
function createBaseSnapAccessToken() {
    return { accessToken: "", scope: "", expiresInSeconds: "0" };
}
exports.SnapAccessToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.accessToken !== "") {
            writer.uint32(10).string(message.accessToken);
        }
        if (message.scope !== "") {
            writer.uint32(18).string(message.scope);
        }
        if (message.expiresInSeconds !== "0") {
            writer.uint32(24).int64(message.expiresInSeconds);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnapAccessToken();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.accessToken = reader.string();
                    break;
                case 2:
                    message.scope = reader.string();
                    break;
                case 3:
                    message.expiresInSeconds = longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSnapAccessToken();
        message.accessToken = object.accessToken ?? "";
        message.scope = object.scope ?? "";
        message.expiresInSeconds = object.expiresInSeconds ?? "0";
        return message;
    },
};
function createBaseSnapAccessTokenPrefetchHint() {
    return { earlyInvalidSecs: "0", earlyPrefetchSecs: "0" };
}
exports.SnapAccessTokenPrefetchHint = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.earlyInvalidSecs !== "0") {
            writer.uint32(8).int64(message.earlyInvalidSecs);
        }
        if (message.earlyPrefetchSecs !== "0") {
            writer.uint32(16).int64(message.earlyPrefetchSecs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnapAccessTokenPrefetchHint();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.earlyInvalidSecs = longToString(reader.int64());
                    break;
                case 2:
                    message.earlyPrefetchSecs = longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSnapAccessTokenPrefetchHint();
        message.earlyInvalidSecs = object.earlyInvalidSecs ?? "0";
        message.earlyPrefetchSecs = object.earlyPrefetchSecs ?? "0";
        return message;
    },
};
function createBaseSnapAccessTokenRequest() {
    return { refreshToken: "", scope: "" };
}
exports.SnapAccessTokenRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.refreshToken !== "") {
            writer.uint32(10).string(message.refreshToken);
        }
        if (message.scope !== "") {
            writer.uint32(18).string(message.scope);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnapAccessTokenRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.refreshToken = reader.string();
                    break;
                case 2:
                    message.scope = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSnapAccessTokenRequest();
        message.refreshToken = object.refreshToken ?? "";
        message.scope = object.scope ?? "";
        return message;
    },
};
function createBaseSnapAccessTokensRequest() {
    return { refreshToken: "", scopes: [], deviceId: "", scopesAsEnums: [] };
}
exports.SnapAccessTokensRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.refreshToken !== "") {
            writer.uint32(10).string(message.refreshToken);
        }
        for (const v of message.scopes) {
            writer.uint32(18).string(v);
        }
        if (message.deviceId !== "") {
            writer.uint32(26).string(message.deviceId);
        }
        writer.uint32(34).fork();
        for (const v of message.scopesAsEnums) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnapAccessTokensRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.refreshToken = reader.string();
                    break;
                case 2:
                    message.scopes.push(reader.string());
                    break;
                case 3:
                    message.deviceId = reader.string();
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.scopesAsEnums.push(reader.int32());
                        }
                    }
                    else {
                        message.scopesAsEnums.push(reader.int32());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSnapAccessTokensRequest();
        message.refreshToken = object.refreshToken ?? "";
        message.scopes = object.scopes?.map((e) => e) || [];
        message.deviceId = object.deviceId ?? "";
        message.scopesAsEnums = object.scopesAsEnums?.map((e) => e) || [];
        return message;
    },
};
function createBaseSnapAccessTokensResponse() {
    return { snapAccessTokens: [], status: 0, prefetchHint: undefined };
}
exports.SnapAccessTokensResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.snapAccessTokens) {
            exports.SnapAccessToken.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.status !== 0) {
            writer.uint32(16).int32(message.status);
        }
        if (message.prefetchHint !== undefined) {
            exports.SnapAccessTokenPrefetchHint.encode(message.prefetchHint, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnapAccessTokensResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.snapAccessTokens.push(exports.SnapAccessToken.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.status = reader.int32();
                    break;
                case 3:
                    message.prefetchHint = exports.SnapAccessTokenPrefetchHint.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSnapAccessTokensResponse();
        message.snapAccessTokens =
            object.snapAccessTokens?.map((e) => exports.SnapAccessToken.fromPartial(e)) || [];
        message.status = object.status ?? 0;
        message.prefetchHint =
            object.prefetchHint !== undefined && object.prefetchHint !== null
                ? exports.SnapAccessTokenPrefetchHint.fromPartial(object.prefetchHint)
                : undefined;
        return message;
    },
};
function createBaseSnapSessionRequest() {
    return { scopes: [], deviceId: "", scopesAsEnums: [] };
}
exports.SnapSessionRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.scopes) {
            writer.uint32(18).string(v);
        }
        if (message.deviceId !== "") {
            writer.uint32(26).string(message.deviceId);
        }
        writer.uint32(34).fork();
        for (const v of message.scopesAsEnums) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnapSessionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    message.scopes.push(reader.string());
                    break;
                case 3:
                    message.deviceId = reader.string();
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.scopesAsEnums.push(reader.int32());
                        }
                    }
                    else {
                        message.scopesAsEnums.push(reader.int32());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSnapSessionRequest();
        message.scopes = object.scopes?.map((e) => e) || [];
        message.deviceId = object.deviceId ?? "";
        message.scopesAsEnums = object.scopesAsEnums?.map((e) => e) || [];
        return message;
    },
};
function createBaseSnapSessionResponse() {
    return {
        refreshToken: "",
        snapAccessTokens: [],
        status: 0,
        prefetchHint: undefined,
    };
}
exports.SnapSessionResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.refreshToken !== "") {
            writer.uint32(10).string(message.refreshToken);
        }
        for (const v of message.snapAccessTokens) {
            exports.SnapAccessToken.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.status !== 0) {
            writer.uint32(24).int32(message.status);
        }
        if (message.prefetchHint !== undefined) {
            exports.SnapAccessTokenPrefetchHint.encode(message.prefetchHint, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnapSessionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.refreshToken = reader.string();
                    break;
                case 2:
                    message.snapAccessTokens.push(exports.SnapAccessToken.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.prefetchHint = exports.SnapAccessTokenPrefetchHint.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSnapSessionResponse();
        message.refreshToken = object.refreshToken ?? "";
        message.snapAccessTokens =
            object.snapAccessTokens?.map((e) => exports.SnapAccessToken.fromPartial(e)) || [];
        message.status = object.status ?? 0;
        message.prefetchHint =
            object.prefetchHint !== undefined && object.prefetchHint !== null
                ? exports.SnapAccessTokenPrefetchHint.fromPartial(object.prefetchHint)
                : undefined;
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=network_tokens.js.map